import React, {Component} from "react";
import withStaticImages from '../../../services/utils/imageNameRetriever';

class RoomCardTooltip extends Component {

    render() {
        let {game_info} = this.props;

        let gameImage = null;
        if (game_info && game_info !== -1) {
            const gameImagePath = this.props.getImage(game_info.image_path);
            gameImage = <img alt='actual_game_image' className='multiplayer_game_image' src={gameImagePath}></img>
        }

        return (
            <div className='room_card_tooltip tw-px-16'>
                {gameImage}
            </div>
        )
        
    }
}

export default withStaticImages('game_icons',RoomCardTooltip);


// WEBPACK FOOTER //
// ./src/components/containers/online-room-list/room_card_tooltip.js